const SsoErrorConstants = {}

SsoErrorConstants.INVALID_CONFIGURATION = 'Whoops, single sign on may not be configured properly for your org.'
SsoErrorConstants.SESSION_EXPIRED = 'Your login token may have timed out, please try logging in again.'
SsoErrorConstants.REQUEST_ID_MESSAGE = `\nIf you're unable to log in, please chat in with the following reference number: `

export default SsoErrorConstants
